interface IStarIcon {
  checked?: boolean;
}

export const StarIcon = (props: IStarIcon) => {
  const { checked = false } = props;
  return (
    <>
      {checked ? (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.81969 2.76285C7.3025 1.74572 8.6975 1.74572 9.18031 2.76285L10.0147 4.52071C10.2065 4.92461 10.5771 5.20456 11.0058 5.26933L12.8716 5.55122C13.9512 5.71432 14.3823 7.09373 13.6011 7.88545L12.251 9.25375C11.9407 9.56815 11.7992 10.0211 11.8724 10.4651L12.1911 12.3971C12.3755 13.5151 11.247 14.3676 10.2813 13.8398L8.6125 12.9276C8.22905 12.718 7.77095 12.718 7.3875 12.9276L5.71866 13.8398C4.75304 14.3676 3.62445 13.5151 3.80887 12.3971L4.12759 10.4651C4.20083 10.0211 4.05927 9.56815 3.74905 9.25376L2.39893 7.88545C1.61772 7.09373 2.0488 5.71432 3.1284 5.55122L4.99422 5.26933C5.42293 5.20456 5.79354 4.92461 5.98526 4.52071L6.81969 2.76285Z"
            fill="#05796B"
          />
          <path
            d="M6.81969 2.76285C7.3025 1.74572 8.6975 1.74572 9.18031 2.76285L10.0147 4.52071C10.2065 4.92461 10.5771 5.20456 11.0058 5.26933L12.8716 5.55122C13.9512 5.71432 14.3823 7.09373 13.6011 7.88545L12.251 9.25375C11.9407 9.56815 11.7992 10.0211 11.8724 10.4651L12.1911 12.3971C12.3755 13.5151 11.247 14.3676 10.2813 13.8398L8.6125 12.9276C8.22905 12.718 7.77095 12.718 7.3875 12.9276L5.71866 13.8398C4.75304 14.3676 3.62445 13.5151 3.80887 12.3971L4.12759 10.4651C4.20083 10.0211 4.05927 9.56815 3.74905 9.25376L2.39893 7.88545C1.61772 7.09373 2.0488 5.71432 3.1284 5.55122L4.99422 5.26933C5.42293 5.20456 5.79354 4.92461 5.98526 4.52071L6.81969 2.76285Z"
            stroke="#05796B"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.81969 2.76285C7.3025 1.74572 8.6975 1.74572 9.18031 2.76285L10.0147 4.52071C10.2065 4.92461 10.5771 5.20456 11.0058 5.26933L12.8716 5.55122C13.9512 5.71432 14.3823 7.09373 13.6011 7.88545L12.251 9.25375C11.9407 9.56815 11.7992 10.0211 11.8724 10.4651L12.1911 12.3971C12.3755 13.5151 11.247 14.3676 10.2813 13.8398L8.6125 12.9276C8.22905 12.718 7.77095 12.718 7.3875 12.9276L5.71866 13.8398C4.75304 14.3676 3.62445 13.5151 3.80887 12.3971L4.12759 10.4651C4.20083 10.0211 4.05927 9.56815 3.74905 9.25375L2.39893 7.88545C1.61772 7.09373 2.0488 5.71432 3.1284 5.55122L4.99422 5.26933C5.42293 5.20456 5.79354 4.92461 5.98526 4.52071L6.81969 2.76285Z"
            stroke="#222530"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  );
};
